import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import useStyles from "./M_UserArea.styles";

const M_UserAvatar = (props) => {
  const classes = useStyles();
  const [imgError, setImgError] = useState(false);
  const src = props.logoImage;

  useEffect(() => {
    setImgError(false);
  }, [src]);

  return src && !imgError ? (
    <img
      src={src}
      alt="Profile"
      className={classes.profileAvatarImage}
      onClick={props.onClick}
      onError={() => setImgError(true)}
    />
  ) : (
    <span className={classes.avatarFallbackLarge} onClick={props.onClick}>
      <FontAwesomeIcon icon={faUser} />
    </span>
  );
};

M_UserAvatar.propTypes = {
  logoImage: PropTypes.string,
  onClick: PropTypes.func,
};

export default M_UserAvatar;
